import { render, staticRenderFns } from "./org-add-or-update.vue?vue&type=template&id=b3ef8876&scoped=true"
import script from "./org-add-or-update.vue?vue&type=script&lang=js"
export * from "./org-add-or-update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3ef8876",
  null
  
)

export default component.exports